export interface NewsBlockModel {
    NewsPageListData: NewsPageListItem[];
    NewsListUrl: string;
}

export interface NewsPageListItem {
    Id: string;
    Header: string;
    ShortDescription: string;
    MainIntro: string;
    Category: string;
    PublishedDate: string;
    Url: string;
    ImageUrl: string;
    AltText: string;
    IsReplacementLanguage: boolean;
}

export function compare(a: NewsPageListItem, b: NewsPageListItem) {
    const dateA = a.PublishedDate;
    const dateB = b.PublishedDate;
    if (dateA < dateB) {
        return -1;
    }
    if (dateA > dateB) {
        return 1;
    }

    return 0;
}
